import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import "../css/PassbookScreen.css";
import "../css/mainhome.css";
import arrowDownIcon from "../assets/icons/down.png";
import AppHeader from "../components/AppHeader";

export default function PassbookScreen() {
  const navigate = useNavigate();
  const walletBalance = localStorage.getItem("walletBalance");

  const [entries, setEntries] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchPassbook(page);
  }, [page]);

  const fetchPassbook = async (pageIndex) => {
    const registerId = localStorage.getItem("registerId");

    if (!registerId) {
      console.error("Missing registerId in localStorage");
      return;
    }

    try {
      const response = await apiClient.post("/passbook-history", {
        registerId: registerId,
        pageIndex: pageIndex,
        recordLimit: 10,
      });

      const { data } = response;
      console.log(data);

      if (data.status && data.info) {
        setEntries(data.info.list || []);
        setTotalPages(data.info.totalPages || 1);
      } else {
        setEntries([]);
      }
    } catch (err) {
      console.error("Error fetching passbook:", err);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <AppHeader
        title="PASSBOOK"
        walletBalance={walletBalance}
        onBack={() => navigate(-1)}
        onWalletClick={() => navigate("/passbook")}
      />

      <div className="table-scroll">
        <table className="passbook-table">
          <thead>
            <tr>
              <th className="narrow-col">Transaction Date</th>
              <th className="wide-col">Particulars</th>
              <th className="wide-col">Previous Amount</th>
              <th className="narrow-col">Transaction Amount</th>
              <th className="narrow-col">Current Amount</th>
              <th className="narrow-col">Remarks</th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "12px" }}>
                  No transactions found.
                </td>
              </tr>
            ) : (
              entries.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.date}
                    <br />
                    {item.time}
                  </td>
                  <td>
                    <div className="particulars-cell">
                      {item.description}
                      <img
                        src={arrowDownIcon}
                        alt="expand"
                        className="down-arrow"
                      />
                    </div>
                  </td>
                  <td>₹{item.previousAmount}</td>
                  <td
                    style={{
                      color: item.transactionAmount.startsWith("-")
                        ? "#d10000"
                        : "#28a745",
                    }}
                  >
                    ₹{item.transactionAmount}
                  </td>
                  <td>₹{item.currentAmount}</td>
                  <td>{item.type}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="pager">
        <button
          className="pager-btn"
          disabled={page === 1}
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
        >
          PREVIOUS
        </button>
        <span className="pager-count">
          ({page}/{totalPages})
        </span>
        <button
          className="pager-btn"
          disabled={page === totalPages}
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
        >
          NEXT
        </button>
      </div>
    </div>
  );
}